import { render } from "./CarrelloShop.vue?vue&type=template&id=a2f83104&scoped=true"
import script from "./CarrelloShop.vue?vue&type=script&lang=js"
export * from "./CarrelloShop.vue?vue&type=script&lang=js"

import "./CarrelloShop.vue?vue&type=style&index=0&id=a2f83104&scoped=true&lang=css"
import "./CarrelloShop.vue?vue&type=style&index=1&id=a2f83104&lang=css"

import exportComponent from "/Users/mattia/Desktop/Projects/elbi-website-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2f83104"]])

export default __exports__